import React from 'react';
import './style.css';

const TextForm = props => {
  return (
    <div className="App-text">
      <form onSubmit={props.handleSubmit} className="form-check">
        <input type="text" value={props.value} onChange={props.handleChange} />
      </form>
    </div>
  );
};

export default TextForm;



// WEBPACK FOOTER //
// ./src/comparison/components/TextForm/index.js